/**
 * Detectar navegador y devolver info
 */
export function detect_browser() {
    const ua = navigator.userAgent;
    let browser = 'Unknown';
    let isSafari = false;

    if (/chrome|chromium|crios/i.test(ua)) browser = 'Chrome';
    else if (/firefox|fxios/i.test(ua)) browser = 'Firefox';
    else if (/safari/i.test(ua)) { browser = 'Safari'; isSafari = true; }
    else if (/opr\//i.test(ua)) browser = 'Opera';
    else if (/edg/i.test(ua)) browser = 'Edge';
    else if (/android/i.test(ua)) browser = 'Android';
    else if (/iphone/i.test(ua)) browser = 'iPhone';

    return { browser, isSafari };
}
